<div class="modal-body">
  <span *ngFor="let message of messages">{{ message | translate }}</span>
</div>
